import { render, staticRenderFns } from "./Board.vue?vue&type=template&id=2d79c239"
import script from "./Board.ts?vue&type=script&lang=ts&external"
export * from "./Board.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports